import { WebAudioSuper } from "./webaudio_super.js";

class WebAudioNodeMaster extends WebAudioSuper {
  namespace = "webaudio:node:master";
}

const webAudioNodeMaster = new WebAudioNodeMaster();
export { webAudioNodeMaster, WebAudioNodeMaster };
